import { Card, Tooltip } from "antd";
import { InfoIconOutlined } from "../../../../../atoms/CustomIcons";

interface RateCardProps {
  title: string;
  tooltip?: string;
  value: number | string;
  showDollarSign?: boolean;
}

export default function RateCard({
  title,
  tooltip,
  value,
  showDollarSign,
}: RateCardProps) {
  return (
    <div className="cardRate">
      <Card
        title={
          <div>
            {title}
            {tooltip && (
              <Tooltip title={tooltip}>
                <InfoIconOutlined />
              </Tooltip>
            )}
          </div>
        }
        variant="borderless"
      >
        {showDollarSign && `$`}{" "}
        {value !== 0 ? value : <span style={{ color: "#98a3a9" }}>...</span>}
      </Card>
    </div>
  );
}
